import React from "react";
import Backdrop from "@mui/material/Backdrop";

export default function LoadingOverlay({
  open = true,
  message = "Loading...",
  fullScreen = true,
}) {
  if (!open) return null;

  return (
    <Backdrop
      open
      className="app-loading-backdrop"
      sx={{
        zIndex: fullScreen ? 1400 : 1200,
        color: "#2563eb",
        backgroundColor: "rgba(15, 23, 42, 0.35)",
        backdropFilter: "blur(2px)",
      }}
    >
      <div className="app-loading-dialog" role="status" aria-live="polite">
        <div className="app-loading-spinner" aria-hidden="true">
          <span className="app-loading-spinner-ring" />
          <span className="app-loading-spinner-core" />
        </div>
        {message ? <p className="app-loading-message">{message}</p> : null}
      </div>
    </Backdrop>
  );
}
